import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import selectors from './selectors';

const options = {
  name: 'absenceRequests',
  baseType: 'ABSENCE_REQUESTS',
  apiEndpoint: 'absence_requests',
  transform: t => ({ ...t, type: 'absence_request' })
};

const operations = createMetadataAPIOperations(options);

export { operations, selectors };
export default createMetadataAPIReducer(options);
